import { Box } from "@chakra-ui/react";
import VmPricingTable from "./vmTable";
import { CLOUD_VM_AMD_DEDICATED } from "./constants";

const AmdDedicatedPricing = () => {
  return (
    <Box id="amd-based-dedicated-cpu">
      <VmPricingTable {...CLOUD_VM_AMD_DEDICATED} />
    </Box>
  );
};

export default AmdDedicatedPricing;
